:host {
    display: block;
}

.feedback {

  ::slotted([slot="title"]) {
      margin-bottom: 50px;
    @include breakpointMax('sm') {
      margin-bottom: 40px;
    }
  }

  &.pdp {
    ::slotted([slot="title"]) {
      margin-bottom: 38px;
    }
  }

  ::slotted([slot="text"]) {
      margin-bottom: 21px;
      max-width: 550px;
  }

  .links {
    display: flex;
    flex-direction: column;
    row-gap: 11px;
  }
}
